import { Component, ViewChild } from '@angular/core';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { TranslateService } from '@ngx-translate/core';
import { Config, Nav, Platform } from 'ionic-angular';
import { FirstRunPage, MainPage } from '../pages/pages';
import { User } from '../providers/providers';



@Component({
  templateUrl: 'app.html'
})

// @Component({
//   template: `<ion-menu [content]="content">
//     <ion-header>
//       <ion-toolbar fixed>
//         <ion-title>Pages</ion-title>
//       </ion-toolbar>
//     </ion-header>

//     <ion-content class="appBackground">
//       <ion-list>
//         <button menuClose ion-item *ngFor="let p of pages" tappable (click)="openPage(p)">
//           {{p.title}}
//         </button>
//       </ion-list>
//     </ion-content>

//   </ion-menu>
//   <ion-nav #content [root]="rootPage"></ion-nav>`
// })
export class MyApp {
  rootPage : any;

  @ViewChild(Nav) nav: Nav;

  // pages: any[] = [
  //   { title: 'Tutorial', component: 'TutorialPage' },
  //   { title: 'Welcome', component: 'WelcomePage' },
  //   { title: 'Tabs', component: 'TabsPage' },
  //   { title: 'Cards', component: 'CardsPage' },
  //   { title: 'Content', component: 'ContentPage' },
  //   { title: 'Login', component: 'LoginPage' },
  //   { title: 'Signup', component: 'SignupPage' },
  //   { title: 'Master Detail', component: 'ListMasterPage' },
  //   { title: 'Menu', component: 'MenuPage' },
  //   { title: 'Settings', component: 'SettingsPage' },
  //   { title: 'Search', component: 'SearchPage' }
  // ]

  constructor(private translate: TranslateService,  public platform: Platform,  private config: Config, private statusBar: StatusBar, private splashScreen: SplashScreen, private user: User) {
    
    platform.ready().then(() => {
      
      // Auth Guard Call
      this.authGuard();

      if (this.platform.is('ios') || this.platform.is("android")) {
        this.statusBar.styleDefault();
        this.splashScreen.hide();
       // Keyboard.disableScroll(true);
        //cordova.plugins.Keyboard.disableScroll(true);
       }
    });
    this.initTranslate();
  }

  initTranslate() {
    // Set the default language for translation strings, and the current language.
    this.translate.setDefaultLang('en');
    if (this.translate.getBrowserLang() !== undefined) {
      this.translate.use(this.translate.getBrowserLang());
    } else {
      this.translate.use('en'); // Set your language here
    }

    this.translate.get(['BACK_BUTTON_TEXT']).subscribe(values => {
      this.config.set('ios', 'backButtonText', values.BACK_BUTTON_TEXT);
    });
  }

  private authGuard(){
    const userDetails = this.user.getData();
    if(userDetails.uid && userDetails.token){
     this.rootPage = MainPage;
    }
    else{
      this.rootPage = FirstRunPage;
    }
  }

  // openPage(page) {
  //   // Reset the content nav to have just this page
  //   // we wouldn't want the back button to show in this scenario
  //   this.nav.setRoot(page.component);
  // }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts